'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447 from "./presto.-Presto-Router$$anon$47.js";
import * as $j_presto$002e$002dRegister$002dPage$0024 from "./presto.-Register-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$46() {
  this.bi0 = null;
  this.bhS = null;
  this.bhT = false;
  this.bi1 = null;
  this.bi2 = false;
  this.bi5 = null;
  this.bhY = null;
  this.bhZ = false;
  this.bhU = null;
  this.bhV = false;
  this.bhW = null;
  this.bhX = false;
  this.bi3 = false;
  this.bi4 = false;
  this.bi0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bi5 = "RegisterPage";
}
export { $c_Lpresto_PrestoRouter$$anon$46 as $c_Lpresto_PrestoRouter$$anon$46 };
$p = $c_Lpresto_PrestoRouter$$anon$46.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$46;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$46() {
}
export { $h_Lpresto_PrestoRouter$$anon$46 as $h_Lpresto_PrestoRouter$$anon$46 };
$h_Lpresto_PrestoRouter$$anon$46.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bi0;
});
$p.M = (function() {
  if ((!this.bhT)) {
    this.bhS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bhT = true;
  }
  return this.bhS;
});
$p.O = (function() {
  if ((!this.bi2)) {
    this.bi1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bi2 = true;
  }
  return this.bi1;
});
$p.E = (function() {
  return this.bi5;
});
$p.t = (function() {
  if ((!this.bhZ)) {
    this.bhY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhZ = true;
  }
  return this.bhY;
});
$p.N = (function() {
  if ((!this.bhV)) {
    this.bhU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhV = true;
  }
  return this.bhU;
});
$p.Q = (function() {
  if ((!this.bhX)) {
    this.bhW = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447.$c_Lpresto_PrestoRouter$$anon$47();
    this.bhX = true;
  }
  return this.bhW;
});
$p.v = (function() {
  if ((!this.bi4)) {
    this.bi3 = false;
    this.bi4 = true;
  }
  return this.bi3;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee377) => ((p) => \u03b4scrutinee377))($j_presto$002e$002dRegister$002dPage$0024.$m_Lpresto_RegisterPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$46 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$46, "presto.PrestoRouter$$anon$46", ({
  Om: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$46 as $d_Lpresto_PrestoRouter$$anon$46 };
//# sourceMappingURL=presto.-Presto-Router$$anon$46.js.map
